import { SESSION_STORAGE_PREFIX } from '../../../../components/PageAnchorScroll/const';
import { GeneralListResponse } from '../../types';

function getListProviderAnchorScrollData<T extends GeneralListResponse>(): T | null {
	const id = window.location.pathname.toLowerCase();
	const sessionStorageValue = window.sessionStorage.getItem(`${SESSION_STORAGE_PREFIX}_${id}_data`);

	if (sessionStorageValue === null) {
		return null;
	}

	try {
		return JSON.parse(sessionStorageValue) as T;
	} catch (e) {
		return null;
	}
}

function tryPersistListProviderAnchorScrollData({ data }: { data: GeneralListResponse }) {
	const id = window.location.pathname.toLowerCase();

	window.sessionStorage.setItem(`${SESSION_STORAGE_PREFIX}_${id}_data`, JSON.stringify(data));
}

function resetListProviderAnchorScrollData() {
	const id = window.location.pathname.toLowerCase();

	window.sessionStorage.removeItem(`${SESSION_STORAGE_PREFIX}_${id}_data`);
}

export { resetListProviderAnchorScrollData, tryPersistListProviderAnchorScrollData, getListProviderAnchorScrollData };
